import { createReducer } from '@api/createRequestStore';
import { SCOPE } from './types';

export default createReducer(SCOPE);
